import { Prisma } from "@prisma/client";

export const eventParticipationRequestTypeValues =
  Prisma.validator<Prisma.ParticipationRequestDefaultArgs>()({
    include: {
      structure: {
        include: {
          products: true,
          businessSectorRelation: true,
        },
      },
    },
  });

export type EventParticipationRequestType =
  Prisma.ParticipationRequestGetPayload<
    typeof eventParticipationRequestTypeValues
  >;
